import React from "react";

const ListServices = () => {
  return <div></div>;
};

export default React.memo(ListServices);
